export default __webpack_public_path__ + "./fonts/tickAuthorizations.c066f150.svg";